import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  active_img,
  deactive_img,
  delete_icon,
  edit_icon,
  eye_icon,
  password_icon,
  search_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { admin_list, user_review_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSearchSelect from '../../components/Searchbox/CustomSearch';
import StarIcon from "@mui/icons-material/Star";
import Swal from "sweetalert2";
import moment from 'moment';
import ReactPaginate from "react-paginate";
import { useLazyPropertiesBlockedDropQuery, useLazyReviewListDeleteQuery, useLazyReviewListStatusQuery, useLazyTotalLocationsListQuery, useReviewListCheckMutation, useReviewListMutation, useReviewListStatusMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const UserReviews = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [list, setList] = useState([]);
  const [pageno, setPageno] = useState(1);
  const [count, setCount] = useState(1)
  const [pagecount, setPagecount] = useState(1);
  const [selectedCityId, setSelectedCityId] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState('');
  const [cities, setCities] = useState([]);
  const [properties, setProperties] = useState([]);
  const [checkBoxID, setCheckBoxID] = useState([])
  const [deleteId, setDeleteId] = useState('');
  const [status, setStatus] = useState();
  const [locationLoader, setLocationLoader] = useState(false);

  const [fromdate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [search, setSearch] = useState("");

  // console.log("delete", deleteId);
  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))


  const [UserReviewsApi] = useReviewListMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [getPropertyApi] = useLazyPropertiesBlockedDropQuery();
  const [reviewListDelete] = useLazyReviewListDeleteQuery();
  const [reviewListStatus] = useReviewListStatusMutation();
  const [reviewListCheckApi] = useReviewListCheckMutation();


  const getLocations = () => {
    setLocationLoader(true)
    getCityApi()
      .unwrap()
      .then((res) => {
        setLocationLoader(false)
        console.log(res);
        let temp = res?.data?.filter((item) => item?.type == 3);
        setCities(temp);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  const getProperty = () => {
    getPropertyApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        const formattedProperties = res?.data
        // const formattedProperties = res?.data?.map((propertyName, index) => ({
        //     value: propertyName?.name,
        //     label: propertyName?.name,
        //     name: propertyName?.name,
        // })) || [];
        setProperties(formattedProperties);


      })
      .catch((err) => {
        console.error(err);
      });
  };

  const reviewList = (fromdate,
    toDate,
    selectedCityId,
    selectedPropertyId,
    search,
    pageno,) => {
    setLoader(true)
    const formdata = new FormData();
    if (fromdate && toDate) {
      formdata.append('from_date', moment(fromdate).format('YYYY-MM-DD'))
      formdata.append('to_date', moment(toDate).format('YYYY-MM-DD'))
    }
    if (selectedPropertyId) {
      formdata.append('property_id', selectedPropertyId)
    }
    if (selectedCityId) {
      formdata.append('city', selectedCityId)
    }
    if (search) {
      formdata.append('search', search)
    }
    formdata.append("type", 1)
    formdata.append("page", pageno)
    formdata.append("row", 10)
    setFromDate(fromdate);
    setToDate(toDate);
    setSelectedPropertyId(selectedPropertyId);
    setSelectedCityId(selectedCityId);
    setSearch(search);

    UserReviewsApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        setList(res?.reviews);

        let temp = []
        res?.reviews?.map((item, ind) => {
          if (item?.home_page_review == 1) {
            temp.push(item?.id)
          }
        })
        setLoader(false)
        setCheckBoxID(temp)
        let tot_count = +res?.pagination?.total / +res?.pagination?.per_page
        setCount(tot_count);
        setPagecount(res?.pagination)
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    getLocations()
    getProperty()
    reviewList(fromdate,
      toDate,
      selectedPropertyId,
      selectedCityId,
      search,
      pageno,)
  }, [pageno])




  const reviewStatus = (id, value) => {
    const formdata = new FormData();
    formdata.append("id", id)
    formdata.append("status", value)
    reviewListStatus(formdata)
      .unwrap()
      .then((res) => {
        console.log("reasds", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          reviewList(fromdate,
            toDate,
            selectedCityId,
            selectedPropertyId,
            search,
            1,)
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }
  const reviewDelete = () => {
    setDeletePopup(true)
    reviewListDelete(deleteId)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          setDeletePopup(false);
          reviewList(fromdate,
            toDate,
            selectedPropertyId,
            selectedCityId,
            search,
            1,);
        } else if (res?.status == "error") {
          setDeletePopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }
  const reviewListCheck = () => {
    const formdata = new FormData();
    checkBoxID?.forEach((item, index) => {
      formdata.append(`property_review_ids[${index}]`, item);
    })
    reviewListCheckApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        toast.success(res?.message);
        setDeletePopup(false);
        reviewList(fromdate,
          toDate,
          selectedCityId,
          selectedPropertyId,
          search,
          1);
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    setList(user_review_list);
  }, []);


  const handleCheckBox = (id) => {
    let temp = [...checkBoxID]
    let inx = temp.indexOf(id)

    if (temp?.includes(id)) {
      temp.splice(inx, 1)
    } else {
      temp.push(id)
    }
    setCheckBoxID(temp)

  }

  console.log('checkBoxID', checkBoxID);


  return (
    <div className="dashRightView home_section">
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
        Review - User
      </h2>
      <div>
        <div className='d-flex ac-js gap-2 flex-wrap'>
          <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >From Date</label>
          <div className="w-15">
            <DatePicker
              selected={fromdate}
              onChange={(e) => {
                reviewList(
                  e,
                  toDate,
                  selectedCityId,
                  selectedPropertyId,
                  search,
                  1,
                )
              }}
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="From Date"
              type="date"
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >To Date</label>
          <div className="w-15">
            <DatePicker
              type="date"
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="To Date"
              selected={toDate}
              onChange={(e) =>
                reviewList(fromdate, e, selectedCityId, selectedPropertyId, search, 1)
              }
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >City</label>
          <CustomSearchSelect
            options={cities}
            locationLoader={locationLoader}
            value={selectedCityId}
            onChange={(value) => {
              reviewList(fromdate, toDate, value, selectedPropertyId, search, 1);
            }}
            placeholder="Select City"
            width="200px"
          />
          <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
            Search
          </label>
          <div className="search-input ">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={search}
              onChange={(e) =>
                reviewList(
                  fromdate,
                  toDate,
                  selectedCityId,
                  selectedPropertyId,
                  e.target.value,
                  1,
                )
              }
            />
            <img src={search_icon} className="search" />
          </div>
          <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >Property </label>
          <CustomSearchSelect
            options={properties}
            value={selectedPropertyId}
            onChange={(value) => {
              setSelectedPropertyId(value);
              reviewList(
                fromdate,
                toDate,
                selectedCityId,
                value,
                search,
                1,
              );
            }}
            placeholder="Select Property"
            width="200px"
          />

        </div>

        <div className="w-100 mt-4 table-responsive">
          <table className="table-design w-100 overflow-scroll ">
            <thead className="px-3 text-center py-2 bg-primar ">
              <th className="d-flex ac-js"><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-3 mb-0">Check</p> {rolePermissions?.includes('CAN-ADD-REVIEWS') && <button onClick={() => reviewListCheck()} className="cust-btn white bg-orange rounded px-2">Activate</button>}</th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0">S.No</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Booking ID</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Property Name</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Owner Name</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">User Name</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Star Rating</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Description</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Status</p></th>
              <th><p className="f6 white fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 mb-0 text-nowrap">Action</p></th>
            </thead>

            {loader ?
              (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
                  <Spinner animation="border" className="primary1" />
                </div>) : (
                <tbody>
                  {list?.map((item, ind) => {
                    return (
                      <tr key={ind} >
                        {rolePermissions?.includes('CAN-ADD-REVIEWS') &&
                          <td className="text-center">
                            <input style={{ height: "20px", width: "20px" }}
                              type={'checkbox'}
                              disabled={item?.status == 2 ? false : true}
                              onClick={() => {
                                if (checkBoxID?.length <= 10) {
                                  handleCheckBox(item?.id);
                                }
                              }}
                              checked={checkBoxID?.includes(item?.id) ? true : false}
                            />
                          </td>}
                        <td ><p className="f4  fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 p-3 mb-0 text-center">{ind + 1}</p></td>
                        <td ><div className="d-flex ac-jc"> <p className="f4 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16  mb-0 text-center">{item?.booking?.booking_id}</p></div></td>
                        <td ><div className="d-flex ac-jc"><p onClick={() => navigate("/property-view", { state: { data: item?.property } })} className="f4 pointer hoverline fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16  mb-0 text-center">{item?.property?.name}</p></div></td>
                        <td > <div className="d-flex ac-jc"><p onClick={() => navigate("/owner-view", { state: { type: "view", id: item?.property?.owner_id } })} className="f4 pointer hoverline fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 text-center">{item?.property?.owner}</p></div></td>
                        <td ><div className="d-flex ac-jc"><p onClick={() => navigate('/user-view', { state: { type: "view", id: item?.reviewer?.id } })} className="f4 pointer hoverline fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16  mb-0 text-center">{item?.reviewer?.name}</p></div></td>
                        <td >
                          <div className="d-flex ac-jc gap-2">
                            <p className="f4  fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 p-2 mb-0 text-center">{item?.rating}</p>
                            <p className="mb-0">
                              <StarIcon style={{ color: "#ffc108" }} />
                            </p>
                          </div>
                        </td>
                        <td><p className="f4 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 p-2 mb-0 text-center">{item?.review?.length > 20
                          ? `${item.review.substring(0, 20)}...`
                          : item?.review}</p></td>
                        {rolePermissions?.includes('CAN-STATUS-REVIEWS') &&
                          <td>
                            {/* {item?.status == 1 ? (
                          <p className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 blocked-btn mb-0 d-flex ac-jc">
                            Requested
                          </p>
                        ) : ( */}
                            <select
                              value={item?.status}
                              onChange={(e) => { reviewStatus(item?.id, e.target.value) }}
                              className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${item?.status == 2 ? "active-btn" : item?.status == 3 ? "suspend-btn" : "blocked-btn"}`}
                            >
                              <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={2}>
                                Active
                              </option>
                              <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={3} >
                                Deactive
                              </option>
                              <option disabled className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1} >
                                Requested
                              </option>
                            </select>
                            {/* )} */}
                          </td>}
                        <td>
                          <div className="d-flex ac-jc">
                            {rolePermissions?.includes('CAN-VIEW-REVIEWS') &&
                              <button
                                onClick={() =>
                                  navigate("/review", {
                                    state: { data: item?.id, routeType: "User" },
                                  })
                                }
                                className="cust-btn "
                              >
                                <img src={view_icon} alt="" className="mx-2 edit-btn " />
                              </button>}
                            {rolePermissions?.includes('CAN-DELETE-REVIEWS') &&
                              <button onClick={() => {
                                setDeleteId(item?.id);  // Set which item to delete
                                setDeletePopup(true);   // Show confirmation
                              }} className="cust-btn ">
                                <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                              </button>}
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>)}
          </table>
          {list?.length == 0 && (
            <p className="text-center f4  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">No Data Available</p>
          )}
        </div>
        {deletePopup && (
          <div className='img-popup-design'>
            <div className='img-popup'>
              <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
                Are you sure, want to Delete?
              </p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button onClick={() => setDeletePopup(false)} className="no-btn">
                  No
                </button>
                <button
                  onClick={() => {
                    reviewDelete(deleteId);
                  }}
                  className="yes-btn f2"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex ac-jb">
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={count} // total number of pages
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={(selectedItem) => {
              setPageno(selectedItem.selected + 1); // if you still need this state
            }}
            containerClassName={"pagination justify-content-start my-4 gap-2 "}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
            width="80%"
          // forcePage={pageIndex} // current page index (zero-based)
          />
          <div className="w-40">
            <div className="d-flex align-items-center justify-content-end">
              <p className="px-1 mb-0">No.Of.Pages</p>
              <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                {pagecount?.last_page}
              </button>
            </div>
          </div>
        </div>
      </div>
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div>
  );
};

export default UserReviews;
